import React, { useState } from 'react';
import { scroller } from 'react-scroll';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import 'font-awesome/css/font-awesome.min.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => setClick(!click);
  const closeMenu = () => setClick(false);

  /**
   * Handles navigation + scrolling logic.
   * If not on home page, navigates home first before scrolling.
   */
  const handleScroll = (section) => {
    closeMenu();

    if (location.pathname !== '/') {
      navigate('/'); // go back home first
      setTimeout(() => {
        scroller.scrollTo(section, {
          duration: 500,
          smooth: true,

        });
      }, 200);
    } else {
      scroller.scrollTo(section, {
        duration: 500,
        smooth: true,

      });
    }
  };

  return (
    <nav className='navbar'>
      <div className='navbar-container'>

        <button className='navbar-logo' onClick={() => handleScroll('home')}>
        </button>

        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fa fa-times' : 'fa fa-bars'} />
        </div>

        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <button className='nav-links' onClick={() => handleScroll('shows')}>
              SHOWS
            </button>
          </li>
          <li className='nav-item'>
            <button className='nav-links' onClick={() => handleScroll('music')}>
              MUSIC
            </button>
          </li>
          <li className='nav-item'>
            <button className='nav-links' onClick={() => handleScroll('videos')}>
              VIDEOS
            </button>
          </li>
          <li className='nav-item'>
            <button className='nav-links' onClick={() => handleScroll('contact')}>
              CONTACT
            </button>
          </li>
          <li className='nav-item'>
            <Link to='/EPK' className='nav-links' onClick={closeMenu}>
              EPK
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
